export const genericMap2Tokens = (legacyThemeProperty, map) => {
  const cssVariables = Object.entries(legacyThemeProperty).reduce((cssVariables, _ref) => {
    let [legacyThemeKey, legacyThemeValue] = _ref;
    const cssVariable = map[legacyThemeKey];
    return !cssVariable ? cssVariables : {
      ...cssVariables,
      [cssVariable]: legacyThemeValue
    };
  }, {});
  return cssVariables;
};